import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-list-bulk-actions',
  templateUrl: './list-bulk-actions.component.html',
  styleUrls: ['./list-bulk-actions.component.css'],
})
export class ListBulkActionsComponent implements OnInit {
  @Input() selected: any[];
  @Input() totalItems: number;
  @Input() disabled: boolean;
  @Input() isLoading: boolean;
  @Input() disabledIfAll = false;
  @Input() actions: TemplateRef<any>;
  @Output() unselect = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  onUnselectAll() {
    this.unselect.emit();
  }
}
